// Reuniones y notas de los scouts: opciones iguales a las del backend (routes/interactions.py)
export const KINDS = [
  { value: 'reunion', label: 'Reunión' },
  { value: 'charla', label: 'Charla' },
  { value: 'llamada', label: 'Llamada' },
  { value: 'mensaje', label: 'Mensaje' },
];

export const COUNTERPARTS = [
  { value: 'club', label: 'Club' },
  { value: 'tecnico', label: 'Técnico' },
  { value: 'gerente_deportivo', label: 'Gerente deportivo' },
  { value: 'jugador', label: 'Jugador' },
  { value: 'padre_madre', label: 'Padre / madre' },
  { value: 'otro', label: 'Otro' },
];

export const formatDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return iso;
  return new Date(y, m - 1, d).toLocaleDateString('es-UY', { day: '2-digit', month: 'short', year: 'numeric' });
};
